import { Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import useEndereco from "core/features/auth/profile/useEndereco";
import useSaveEndereco from "core/features/auth/profile/useSaveEndereco";
import { EnderecoDto } from "core/features/unidades/typings/unidade";
import { showErrorAxios } from "infra/helpers/alerta";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import CardDefault from "ui/components/Cards/CardDefault";
import DadosDeEndereco from "ui/components/FormEndereco";
import { useLoading } from "ui/components/GlobalLoading";

interface FormEndereco {
  endereco: EnderecoDto;
}

function DadosCadastraisTab() {
  const { data, isLoading, isFetching, refetch } = useEndereco();
  const { mutate: handleSave, isLoading: isLoadingSave } = useSaveEndereco();

  const { control, reset, handleSubmit, watch, setValue, formState } =
    useForm<FormEndereco>({
      mode: "all",
    });

  useEffect(() => {
    if (data) {
      reset({ endereco: data });
    }
  }, [data, reset]);

  const onSubmit = async (data: FormEndereco) => {
    handleSave(data.endereco, {
      onSuccess: refetch,
      onError: (e) => {
        showErrorAxios(e);
      },
    });
  };

  useLoading(isLoading);

  return (
    <CardDefault>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Text mb="16px" fontSize="18px">
          Endereço
        </Text>

        <DadosDeEndereco control={control} setField={setValue} watch={watch} />
        <Flex w="100%" justifyContent="flex-end" mt={16}>
          <PrimaryButton
            type="submit"
            isLoading={isLoadingSave || isFetching}
            disabled={!formState.isValid}
          >
            Salvar alterações
          </PrimaryButton>
        </Flex>
      </form>
    </CardDefault>
  );
}

export default DadosCadastraisTab;
